var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIconPasswordLineGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3634 13.2728L17.9089 14.8182L20.9998 11.7273L19.4543 10.1819",
    stroke: "#54BD95",
    strokeWidth: 2.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9142 13.0857L20.9999 4",
    stroke: "#54BD95",
    strokeWidth: 2.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63636 20.9999C11.197 20.9999 13.2727 18.9241 13.2727 16.3635C13.2727 13.8029 11.197 11.7272 8.63636 11.7272C6.07577 11.7272 4 13.8029 4 16.3635C4 18.9241 6.07577 20.9999 8.63636 20.9999Z",
    stroke: "#54BD95",
    strokeWidth: 2.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIconPasswordLineGreen);
export default __webpack_public_path__ + "static/media/login_icon_password_line_green.45bc4ee94a2f5cd0a7025fbd07b66f46.svg";
export { ForwardRef as ReactComponent };